import { default as indexmu5LzXdR9UMeta } from "/app/frontend/pages/darba-lapas/[productSlug]/index.vue?macro=true";
import { default as indexX0RZdBY6NQMeta } from "/app/frontend/pages/darba-lapas/index.vue?macro=true";
import { default as parskats2vFvoW2uJSMeta } from "/app/frontend/pages/darba-lapas/parskats.vue?macro=true";
import { default as index16MQHwPSvQMeta } from "/app/frontend/pages/e-gramatas/[productSlug]/index.vue?macro=true";
import { default as indexiPaudW4vGwMeta } from "/app/frontend/pages/e-gramatas/index.vue?macro=true";
import { default as indexveLFljomDmMeta } from "/app/frontend/pages/index.vue?macro=true";
import { default as indexAvtJwuYNSBMeta } from "/app/frontend/pages/interaktivie-materiali/[productSlug]/index.vue?macro=true";
import { default as indexugChkelJLOMeta } from "/app/frontend/pages/interaktivie-materiali/index.vue?macro=true";
import { default as index086DPkvHo0Meta } from "/app/frontend/pages/link/[code]/index.vue?macro=true";
import { default as mani_45zurnalizbUkgcevhRMeta } from "/app/frontend/pages/mani-zurnali.vue?macro=true";
import { default as indexsXnfmjfmkLMeta } from "/app/frontend/pages/metodiskie-lidzekli/[productSlug]/index.vue?macro=true";
import { default as indexEnxtQtmTtzMeta } from "/app/frontend/pages/metodiskie-lidzekli/index.vue?macro=true";
import { default as _91slug_93bMQs7ZMPA0Meta } from "/app/frontend/pages/pdf-reader/[slug].vue?macro=true";
import { default as playlistsMbYJp5DvK4Meta } from "/app/frontend/pages/playlists.vue?macro=true";
import { default as stylebookpKt0tui1JxMeta } from "/app/frontend/pages/stylebook.vue?macro=true";
import { default as indexmTqC9mp99NMeta } from "/app/frontend/pages/video/[productSlug]/index.vue?macro=true";
import { default as indexysGJQKWa2KMeta } from "/app/frontend/pages/video/index.vue?macro=true";
import { default as viedgramataogEy6J0TgMMeta } from "/app/frontend/pages/viedgramata.vue?macro=true";
import { default as contentsQkUdA1iYdxMeta } from "/app/frontend/pages/viedtema/[smartFileSlug]/contents.vue?macro=true";
import { default as indexO3vVX0lO8XMeta } from "/app/frontend/pages/viedtema/[smartFileSlug]/index.vue?macro=true";
import { default as contentsZyW10ZlaZpMeta } from "/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/contents.vue?macro=true";
import { default as indexo1oNLuVmtzMeta } from "/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/index.vue?macro=true";
import { default as indexLoEn7K07brMeta } from "/app/frontend/pages/viedtemas/[subjectSlug]/[gradeSlug]/[productSlug]/[sectionSlug]/index.vue?macro=true";
import { default as indexLywzlguLv5Meta } from "/app/frontend/pages/viedtemas/[subjectSlug]/index.vue?macro=true";
import { default as indexVoFLhNHM42Meta } from "/app/frontend/pages/viedtemas/index.vue?macro=true";
import { default as _91slug_93rJh9Bs1UAYMeta } from "~/pages/pdf-reader/[slug].vue?macro=true";
export default [
  {
    name: indexmu5LzXdR9UMeta?.name ?? "darba-lapas-productSlug",
    path: indexmu5LzXdR9UMeta?.path ?? "/darba-lapas/:productSlug()",
    meta: indexmu5LzXdR9UMeta || {},
    alias: indexmu5LzXdR9UMeta?.alias || [],
    redirect: indexmu5LzXdR9UMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/darba-lapas/[productSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexX0RZdBY6NQMeta?.name ?? "darba-lapas",
    path: indexX0RZdBY6NQMeta?.path ?? "/darba-lapas",
    meta: indexX0RZdBY6NQMeta || {},
    alias: indexX0RZdBY6NQMeta?.alias || [],
    redirect: indexX0RZdBY6NQMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/darba-lapas/index.vue").then(m => m.default || m)
  },
  {
    name: parskats2vFvoW2uJSMeta?.name ?? "darba-lapas-parskats",
    path: parskats2vFvoW2uJSMeta?.path ?? "/darba-lapas/parskats",
    meta: parskats2vFvoW2uJSMeta || {},
    alias: parskats2vFvoW2uJSMeta?.alias || [],
    redirect: parskats2vFvoW2uJSMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/darba-lapas/parskats.vue").then(m => m.default || m)
  },
  {
    name: index16MQHwPSvQMeta?.name ?? "e-gramatas-productSlug",
    path: index16MQHwPSvQMeta?.path ?? "/e-gramatas/:productSlug()",
    meta: index16MQHwPSvQMeta || {},
    alias: index16MQHwPSvQMeta?.alias || [],
    redirect: index16MQHwPSvQMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/e-gramatas/[productSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexiPaudW4vGwMeta?.name ?? "e-gramatas",
    path: indexiPaudW4vGwMeta?.path ?? "/e-gramatas",
    meta: indexiPaudW4vGwMeta || {},
    alias: indexiPaudW4vGwMeta?.alias || [],
    redirect: indexiPaudW4vGwMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/e-gramatas/index.vue").then(m => m.default || m)
  },
  {
    name: indexveLFljomDmMeta?.name ?? "index",
    path: indexveLFljomDmMeta?.path ?? "/",
    meta: indexveLFljomDmMeta || {},
    alias: indexveLFljomDmMeta?.alias || [],
    redirect: indexveLFljomDmMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/index.vue").then(m => m.default || m)
  },
  {
    name: indexAvtJwuYNSBMeta?.name ?? "interaktivie-materiali-productSlug",
    path: indexAvtJwuYNSBMeta?.path ?? "/interaktivie-materiali/:productSlug()",
    meta: indexAvtJwuYNSBMeta || {},
    alias: indexAvtJwuYNSBMeta?.alias || [],
    redirect: indexAvtJwuYNSBMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/interaktivie-materiali/[productSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexugChkelJLOMeta?.name ?? "interaktivie-materiali",
    path: indexugChkelJLOMeta?.path ?? "/interaktivie-materiali",
    meta: indexugChkelJLOMeta || {},
    alias: indexugChkelJLOMeta?.alias || [],
    redirect: indexugChkelJLOMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/interaktivie-materiali/index.vue").then(m => m.default || m)
  },
  {
    name: index086DPkvHo0Meta?.name ?? "link-code",
    path: index086DPkvHo0Meta?.path ?? "/link/:code()",
    meta: index086DPkvHo0Meta || {},
    alias: index086DPkvHo0Meta?.alias || [],
    redirect: index086DPkvHo0Meta?.redirect || undefined,
    component: () => import("/app/frontend/pages/link/[code]/index.vue").then(m => m.default || m)
  },
  {
    name: mani_45zurnalizbUkgcevhRMeta?.name ?? "mani-zurnali",
    path: mani_45zurnalizbUkgcevhRMeta?.path ?? "/mani-zurnali",
    meta: mani_45zurnalizbUkgcevhRMeta || {},
    alias: mani_45zurnalizbUkgcevhRMeta?.alias || [],
    redirect: mani_45zurnalizbUkgcevhRMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/mani-zurnali.vue").then(m => m.default || m)
  },
  {
    name: indexsXnfmjfmkLMeta?.name ?? "metodiskie-lidzekli-productSlug",
    path: indexsXnfmjfmkLMeta?.path ?? "/metodiskie-lidzekli/:productSlug()",
    meta: indexsXnfmjfmkLMeta || {},
    alias: indexsXnfmjfmkLMeta?.alias || [],
    redirect: indexsXnfmjfmkLMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/metodiskie-lidzekli/[productSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexEnxtQtmTtzMeta?.name ?? "metodiskie-lidzekli",
    path: indexEnxtQtmTtzMeta?.path ?? "/metodiskie-lidzekli",
    meta: indexEnxtQtmTtzMeta || {},
    alias: indexEnxtQtmTtzMeta?.alias || [],
    redirect: indexEnxtQtmTtzMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/metodiskie-lidzekli/index.vue").then(m => m.default || m)
  },
  {
    name: _91slug_93bMQs7ZMPA0Meta?.name ?? "pdf-reader-slug",
    path: _91slug_93bMQs7ZMPA0Meta?.path ?? "/pdf-reader/:slug()",
    meta: _91slug_93bMQs7ZMPA0Meta || {},
    alias: _91slug_93bMQs7ZMPA0Meta?.alias || [],
    redirect: _91slug_93bMQs7ZMPA0Meta?.redirect || undefined,
    component: () => import("/app/frontend/pages/pdf-reader/[slug].vue").then(m => m.default || m)
  },
  {
    name: playlistsMbYJp5DvK4Meta?.name ?? "playlists",
    path: playlistsMbYJp5DvK4Meta?.path ?? "/playlists",
    meta: playlistsMbYJp5DvK4Meta || {},
    alias: playlistsMbYJp5DvK4Meta?.alias || [],
    redirect: playlistsMbYJp5DvK4Meta?.redirect || undefined,
    component: () => import("/app/frontend/pages/playlists.vue").then(m => m.default || m)
  },
  {
    name: stylebookpKt0tui1JxMeta?.name ?? "stylebook",
    path: stylebookpKt0tui1JxMeta?.path ?? "/stylebook",
    meta: stylebookpKt0tui1JxMeta || {},
    alias: stylebookpKt0tui1JxMeta?.alias || [],
    redirect: stylebookpKt0tui1JxMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/stylebook.vue").then(m => m.default || m)
  },
  {
    name: indexmTqC9mp99NMeta?.name ?? "video-productSlug",
    path: indexmTqC9mp99NMeta?.path ?? "/video/:productSlug()",
    meta: indexmTqC9mp99NMeta || {},
    alias: indexmTqC9mp99NMeta?.alias || [],
    redirect: indexmTqC9mp99NMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/video/[productSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexysGJQKWa2KMeta?.name ?? "video",
    path: indexysGJQKWa2KMeta?.path ?? "/video",
    meta: indexysGJQKWa2KMeta || {},
    alias: indexysGJQKWa2KMeta?.alias || [],
    redirect: indexysGJQKWa2KMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/video/index.vue").then(m => m.default || m)
  },
  {
    name: viedgramataogEy6J0TgMMeta?.name ?? "viedgramata",
    path: viedgramataogEy6J0TgMMeta?.path ?? "/viedgramata",
    meta: viedgramataogEy6J0TgMMeta || {},
    alias: viedgramataogEy6J0TgMMeta?.alias || [],
    redirect: viedgramataogEy6J0TgMMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedgramata.vue").then(m => m.default || m)
  },
  {
    name: contentsQkUdA1iYdxMeta?.name ?? "viedtema-smartFileSlug-contents",
    path: contentsQkUdA1iYdxMeta?.path ?? "/viedtema/:smartFileSlug()/contents",
    meta: contentsQkUdA1iYdxMeta || {},
    alias: contentsQkUdA1iYdxMeta?.alias || [],
    redirect: contentsQkUdA1iYdxMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/contents.vue").then(m => m.default || m)
  },
  {
    name: indexO3vVX0lO8XMeta?.name ?? "viedtema-smartFileSlug",
    path: indexO3vVX0lO8XMeta?.path ?? "/viedtema/:smartFileSlug()",
    meta: indexO3vVX0lO8XMeta || {},
    alias: indexO3vVX0lO8XMeta?.alias || [],
    redirect: indexO3vVX0lO8XMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtema/[smartFileSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: contentsZyW10ZlaZpMeta?.name ?? "viedtema-subjectSlug-gradeSlug-sectionSlug-smartFileSlug-contents",
    path: contentsZyW10ZlaZpMeta?.path ?? "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()/contents",
    meta: contentsZyW10ZlaZpMeta || {},
    alias: contentsZyW10ZlaZpMeta?.alias || [],
    redirect: contentsZyW10ZlaZpMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/contents.vue").then(m => m.default || m)
  },
  {
    name: indexo1oNLuVmtzMeta?.name ?? "viedtema-subjectSlug-gradeSlug-sectionSlug-smartFileSlug",
    path: indexo1oNLuVmtzMeta?.path ?? "/viedtema/:subjectSlug()/:gradeSlug()/:sectionSlug()/:smartFileSlug()",
    meta: indexo1oNLuVmtzMeta || {},
    alias: indexo1oNLuVmtzMeta?.alias || [],
    redirect: indexo1oNLuVmtzMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtema/[subjectSlug]/[gradeSlug]/[sectionSlug]/[smartFileSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLoEn7K07brMeta?.name ?? "viedtemas-subjectSlug-gradeSlug-productSlug-sectionSlug",
    path: indexLoEn7K07brMeta?.path ?? "/viedtemas/:subjectSlug()/:gradeSlug()/:productSlug()/:sectionSlug()",
    meta: indexLoEn7K07brMeta || {},
    alias: indexLoEn7K07brMeta?.alias || [],
    redirect: indexLoEn7K07brMeta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtemas/[subjectSlug]/[gradeSlug]/[productSlug]/[sectionSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexLywzlguLv5Meta?.name ?? "viedtemas-subjectSlug",
    path: indexLywzlguLv5Meta?.path ?? "/viedtemas/:subjectSlug()",
    meta: indexLywzlguLv5Meta || {},
    alias: indexLywzlguLv5Meta?.alias || [],
    redirect: indexLywzlguLv5Meta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtemas/[subjectSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: indexVoFLhNHM42Meta?.name ?? "viedtemas",
    path: indexVoFLhNHM42Meta?.path ?? "/viedtemas",
    meta: indexVoFLhNHM42Meta || {},
    alias: indexVoFLhNHM42Meta?.alias || [],
    redirect: indexVoFLhNHM42Meta?.redirect || undefined,
    component: () => import("/app/frontend/pages/viedtemas/index.vue").then(m => m.default || m)
  },
  {
    path: _91slug_93rJh9Bs1UAYMeta?.path ?? "/e-gramatas/:slug/pdf",
    name: _91slug_93rJh9Bs1UAYMeta?.name ?? undefined,
    meta: _91slug_93rJh9Bs1UAYMeta || {},
    alias: _91slug_93rJh9Bs1UAYMeta?.alias || [],
    redirect: _91slug_93rJh9Bs1UAYMeta?.redirect || undefined,
    component: () => import("~/pages/pdf-reader/[slug].vue").then(m => m.default || m)
  },
  {
    path: _91slug_93rJh9Bs1UAYMeta?.path ?? "/darba-lapas/:slug/pdf",
    name: _91slug_93rJh9Bs1UAYMeta?.name ?? undefined,
    meta: _91slug_93rJh9Bs1UAYMeta || {},
    alias: _91slug_93rJh9Bs1UAYMeta?.alias || [],
    redirect: _91slug_93rJh9Bs1UAYMeta?.redirect || undefined,
    component: () => import("~/pages/pdf-reader/[slug].vue").then(m => m.default || m)
  },
  {
    path: _91slug_93rJh9Bs1UAYMeta?.path ?? "/metodiskie-lidzekli/:slug/pdf",
    name: _91slug_93rJh9Bs1UAYMeta?.name ?? undefined,
    meta: _91slug_93rJh9Bs1UAYMeta || {},
    alias: _91slug_93rJh9Bs1UAYMeta?.alias || [],
    redirect: _91slug_93rJh9Bs1UAYMeta?.redirect || undefined,
    component: () => import("~/pages/pdf-reader/[slug].vue").then(m => m.default || m)
  }
]